import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMarkupDetails } from '@Actions/documentActions';
import { ScoreCardItemDetails } from '@Pages/Scorecards/components/ScoreCardItemDetails';
import { LabelDetails } from '@Pages/Labels/components/LabelDetails';
import { CardsContainer } from './MarkupDetails.style';
import { Drawer } from '@Components/Drawer';
const MarkupDetails = () => {
    const { isMarkupDetailsVisible, markupDetails } = useSelector(state => state.document);

    const dispatch = useDispatch();

    const close = () => {
        dispatch(toggleMarkupDetails(false));
    };

    const renderRiskCards = () =>
        markupDetails.map((p, i) => {
            return p.riskLevel ? (
                <ScoreCardItemDetails {...p} key={i} />
            ) : (
                <LabelDetails {...p} key={i} />
            );
        });

    return (
        <Drawer dir={'right'} isOpen={isMarkupDetailsVisible} close={close} title="Details">
            <CardsContainer>{renderRiskCards()}</CardsContainer>
        </Drawer>
    );
};

export { MarkupDetails };
